import { forwardRef } from 'react';
import { Label } from '@accure/ui';

import { Hint } from '../hint';
import {
  TextareaInput,
  type TextareaInputProps,
} from '../inputs/textarea-input';

export type TextareaFieldProps = TextareaInputProps & {
  label?: string;
  hint?: string;
};

export const TextareaField = forwardRef<
  HTMLTextAreaElement,
  TextareaFieldProps
>(function ({ label, error, hint, ...props }, ref) {
  return (
    <div className="space-y-2">
      {label ? <Label>{label}</Label> : null}
      <TextareaInput ref={ref} {...props} error={error} />
      {hint ? <Hint>{hint}</Hint> : null}
    </div>
  );
});

TextareaField.displayName = 'TextareaField';
